import { render, staticRenderFns } from "./RescheduleSettingsPage.vue?vue&type=template&id=265cb15d&scoped=true"
import script from "./RescheduleSettingsPage.vue?vue&type=script&lang=js"
export * from "./RescheduleSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./RescheduleSettingsPage.vue?vue&type=style&index=0&id=265cb15d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265cb15d",
  null
  
)

export default component.exports